export enum ReportRowType {
  Header = 'header',
  Footer = 'footer',
  Account = 'account',
  Group = 'group',
  Section = 'section',
  Sum = 'sum',
}
